// components/loading/Loading.jsx
import React, { useEffect, useState } from 'react';
import './Loading.css';

const Loading = ({ visible, onClose }) => {
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    if (!visible) {
      const timeout = setTimeout(() => setShouldRender(false), 500); // Match CSS transition
      return () => clearTimeout(timeout);
    } else {
      setShouldRender(true);
    }
  }, [visible]);

  if (!shouldRender) return null;

  return (
    <div className={`loading-screen ${visible ? 'fade-in' : 'fade-out'}`}>
      <div className="popup">
        <h2>Performance Tip</h2>
        <p>
          For the best experience, please ensure <strong>graphics acceleration</strong> is enabled in your browser settings.
        </p>
        <button className="close-btn" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default Loading;
